(function() { window.GUID_73e4401a_d5b8_4b8c_9380_72fbed7ea0d1 = { getGuid: function() { return "73e4401a-d5b8-4b8c-9380-72fbed7ea0d1"; } }; })();
var CS;
(function (CS) {
    class Url {
        constructor() {
            var getUrl = window.location;
            this.baseUrl = getUrl.protocol + "//" + getUrl.host + "/";
        }
        static IsLocal(url) {
            var blobStart = "blob:http";
            if (url.substr(0, 1) == "/" ||
                url.substr(0, blobStart.length) == blobStart)
                return true;
            if (url.indexOf("://") != -1)
                return url.toLocaleLowerCase().indexOf(Url.BaseUrl().toLowerCase()) > 0;
            return true;
        }
        /**
         * Return a base url in this format: [protocol]://[Host]/
         */
        static BaseUrl() {
            if (CS.Url.Instance == null) {
                CS.Url.Instance = new Url();
            }
            return CS.Url.Instance.baseUrl;
        }
        static Action(action, controller, queryString = null) {
            if (CS.Url.Instance == null) {
                CS.Url.Instance = new Url();
            }
            let url = `${CS.Url.Instance.baseUrl}${controller}/`;
            if (action != null && action != "") {
                url += `${action}/`;
            }
            if (queryString != null) {
                url += queryString;
            }
            return url;
        }
        /**
         * Append the baseUrl to the route string value
         * @param route route part without the baseurl
         */
        static Route(route) {
            return Url.BaseUrl() + route;
        }
        static MatchDetails(eventId, divisionId, bracketId, matchId) {
            return `${this.Bracket(eventId, divisionId, bracketId, matchId)}MatchDetails/`;
        }
        static MatchCard(eventId, divisionId, bracketId, matchId) {
            return `${this.Bracket(eventId, divisionId, bracketId, matchId)}MatchCard/`;
        }
        static BracketShow(eventId, divisionId, bracketId, matchId) {
            return `${this.Bracket(eventId, divisionId, bracketId, matchId)}Bracket/Show/`;
        }
        static Bracket(eventId, divisionId, bracketId, matchId) {
            if (CS.Url.Instance == null) {
                CS.Url.Instance = new Url();
            }
            if (bracketId) {
                if (matchId) {
                    return `${CS.Url.Instance.baseUrl}/Event/${eventId}/Division/${divisionId}/Bracket/${bracketId}/Match/${matchId}/`;
                }
                else {
                    return `${CS.Url.Instance.baseUrl}/Event/${eventId}/Division/${divisionId}/Bracket/${bracketId}/`;
                }
            }
            else {
                return `${CS.Url.Instance.baseUrl}/Event/${eventId}/Division/${divisionId}/Brackets/`;
            }
        }
        static ShowOpponent(eventId, opponentId) {
            if (CS.Url.Instance == null) {
                CS.Url.Instance = new Url();
            }
            return `${CS.Url.Instance.baseUrl}Event/${eventId}/Opponent/${opponentId}/Show/`;
        }
        static SchedulesOfDivision(eventId, divisionId, personaId, personaType) {
            if (CS.Url.Instance == null) {
                CS.Url.Instance = new Url();
            }
            let url = `${CS.Url.Instance.baseUrl}Event/${eventId}/Division/${divisionId}/`;
            if (personaId) {
                url += `/${personaType}/${personaId}`;
            }
            return `${url}/SchedulesOfDivision`;
        }
        //public static RemoveQueryString(url: string) {
        //    if (url.indexOf("?") > 0) {
        //        var clean_uri = url.substring(0, url.indexOf("?"));
        //TODO:Need to use popstate otherwise it breaks back
        //        window.history.replaceState({}, document.title, clean_uri);
        //    }
        //}
        /**
         * Returns the value of the input element with the id of csurl-[name]. Case insensitive.
         * @param name The name of the input element without the csurl- prefix
         * @param trimAsyncIfNotFound If true and if the element is not found, it will remove the word "async" from the name and try again. Default is false. This parameter was added because there was a lot of renaming to add "Async" to controller methods without changing their references in the CSUrl.cs file.
         */
        static CSUrl(name) {
            name = name.toLowerCase();
            let $element = $("#csurl-" + name);
            //if ($element.length == 0 && trimAsyncIfNotFound) {
            //  if (name.endsWith("async")) { 
            //    const indexOfAsync = name.lastIndexOf("async");
            //    $element = $("#csurl-" + name.substring(0, indexOfAsync));
            //  }
            //}
            if ($element.length > 0) {
                return $element.val();
            }
            else {
                return null;
            }
        }
        static AddOrUpdateQueryStringParameter(url, key, value) {
            try {
                const containsOrigin = url.indexOf(window.location.origin) !== -1;
                if (!containsOrigin)
                    url = window.location.origin + url;
                const urlObject = new URL(url);
                const queryString = urlObject.search;
                const urlParams = new URLSearchParams(queryString);
                const param = urlParams.get(key);
                if (param) {
                    urlParams.set(key, value);
                }
                else {
                    urlParams.append(key, value);
                }
                return containsOrigin
                    ? urlObject.origin + urlObject.pathname + "?" + urlParams
                    : urlObject.pathname + "?" + urlParams;
            }
            catch (error) {
                console.error(error);
                return url;
            }
        }
    }
    CS.Url = Url;
})(CS || (CS = {}));

//# sourceMappingURL=cs-urlhelper.pre.js.map
